import { makeActionCreator } from '../util/state'

import {
  FETCH_CREATE_SCENE,
  FETCH_CREATE_SCENE_SUCCESS,
  FETCH_CREATE_SLATE,
  FETCH_CREATE_SLATE_SUCCESS,
  FETCH_CREATE_TAKE,
  FETCH_CREATE_TAKE_SUCCESS,
  FETCH_DELETE_SCENE,
  FETCH_DELETE_SCENE_SUCCESS,
  FETCH_DELETE_SLATE,
  FETCH_DELETE_SLATE_SUCCESS,
  FETCH_DELETE_TAKE,
  FETCH_DELETE_TAKE_SUCCESS,
  FETCH_SAVE_SCENE,
  FETCH_SAVE_SCENE_SUCCESS,
  FETCH_SAVE_SLATE,
  FETCH_SAVE_SLATE_SUCCESS,
  FETCH_SAVE_TAKE,
  FETCH_SAVE_TAKE_SUCCESS,
  FETCH_SCRIPT,
  FETCH_SCRIPT_SUCCESS,
  UPDATE_SCENE,
  UPDATE_SLATE,
  UPDATE_TAKE
} from '../constants/ActionTypes'

export const fetchScript = makeActionCreator(FETCH_SCRIPT)
export const fetchScriptSuccess = makeActionCreator(FETCH_SCRIPT_SUCCESS, 'scenes', 'slates', 'takes')

export const fetchCreateScene = makeActionCreator(FETCH_CREATE_SCENE)
export const fetchCreateSceneSuccess = makeActionCreator(FETCH_CREATE_SCENE_SUCCESS, 'entry', 'message')
export const fetchCreateSlate = makeActionCreator(FETCH_CREATE_SLATE, 'sceneId')
export const fetchCreateSlateSuccess = makeActionCreator(FETCH_CREATE_SLATE_SUCCESS, 'sceneId', 'entry', 'message')
export const fetchCreateTake = makeActionCreator(FETCH_CREATE_TAKE, 'sceneId', 'slateId')
export const fetchCreateTakeSuccess = makeActionCreator(FETCH_CREATE_TAKE_SUCCESS, 'slateId', 'entry', 'message')

export const updateScene = makeActionCreator(UPDATE_SCENE, 'id', 'fieldName', 'fieldValue')
export const updateSlate = makeActionCreator(UPDATE_SLATE, 'id', 'fieldName', 'fieldValue')
export const updateTake = makeActionCreator(UPDATE_TAKE, 'id', 'fieldName', 'fieldValue')

export const fetchSaveScene = makeActionCreator(FETCH_SAVE_SCENE, 'id')
export const fetchSaveSceneSuccess = makeActionCreator(FETCH_SAVE_SCENE_SUCCESS, 'id', 'message')
export const fetchSaveSlate = makeActionCreator(FETCH_SAVE_SLATE, 'id')
export const fetchSaveSlateSuccess = makeActionCreator(FETCH_SAVE_SLATE_SUCCESS, 'id', 'message')
export const fetchSaveTake = makeActionCreator(FETCH_SAVE_TAKE, 'id')
export const fetchSaveTakeSuccess = makeActionCreator(FETCH_SAVE_TAKE_SUCCESS, 'id', 'message')

export const fetchDeleteScene = makeActionCreator(FETCH_DELETE_SCENE, 'id')
export const fetchDeleteSceneSuccess = makeActionCreator(FETCH_DELETE_SCENE_SUCCESS, 'id', 'message')
export const fetchDeleteSlate = makeActionCreator(FETCH_DELETE_SLATE, 'id', 'sceneId')
export const fetchDeleteSlateSuccess = makeActionCreator(FETCH_DELETE_SLATE_SUCCESS, 'id', 'sceneId', 'message')
export const fetchDeleteTake = makeActionCreator(FETCH_DELETE_TAKE, 'id', 'slateId')
export const fetchDeleteTakeSuccess = makeActionCreator(FETCH_DELETE_TAKE_SUCCESS, 'id', 'slateId', 'message')




// WEBPACK FOOTER //
// ./actions/Script.js